// Sliding session (backend routes/auth.py get_me): /auth/me answers with a fresh token when the one
// sent is more than a day old, so a reader who opens the app is never signed out after 30 days.
const JWT_RE = /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/;

/**
 * Store a renewed token the way sign-in does (localStorage `torre_token`; inside the app the shell
 * copies it to the keychain) and return the user without it. Only when the stored token is still
 * the one the request was sent with: a sign-out while /auth/me was on its way must not be undone
 * by its answer, nor a sign-in to another account overwritten.
 */
export function applySessionRenewal(data, sentToken, storage) {
  if (!data || typeof data !== 'object') return data;
  const { renewed_token: renewed, ...user } = data;
  if (typeof renewed === 'string' && JWT_RE.test(renewed) && renewed.length < 4096) {
    try {
      const store = storage || window.localStorage;
      if (sentToken && store.getItem('torre_token') === sentToken) store.setItem('torre_token', renewed);
    } catch { /* storage unavailable: the current token keeps working until it expires */ }
  }
  return user;
}
